import loadable from '@loadable/component';

const Aup = loadable(() => import('./Terms/Aup'));

const Ari = loadable(() => import('./Ari/Ari'));

const AriJobLanding = loadable(() => import('./Ari/AriJobLanding'));

const AnswerPublicQuestion = loadable(() =>
  import('./AnswerPublicQuestion/AnswerPublicQuestion')
);

const ApplyForVerification = loadable(() =>
  import('./ApplyForVerification/ApplyForVerification')
);

const AuthCode = loadable(() => import('./AuthCode/AuthCode'));

const BetterPic = loadable(() => import('./BetterPic/BetterPic'));

const BillContainer = loadable(() => import('./Bills/Bill'));

const BriefDetailsClient = loadable(() =>
  import('./BriefDetailsClient/BriefDetailsClient')
);

const JobDetails = loadable(() => import('./ClientATS/JobDetails'));

const RecentJobRedirect = loadable(() =>
  import('./ClientATS/RecentJobRedirect')
);

const Copyright = loadable(() => import('./Copyright/Copyright'));

const EngagementTerms = loadable(() => import('./Terms/EngagementTerms'));

const HowItWorks = loadable(() => import('./HowItWorks/HowItWorks'));

const ManageBriefs = loadable(() => import('./ManageBriefs/ManageBriefs'));

const ManagePitches = loadable(() => import('./ManagePitches/ManagePitches'));

const MicroProjects = loadable(() => import('./MicroProjects/MicroProjects'));

const Messages = loadable(() => import('./Messages/Messages'));

const NotFound = loadable(() => import('./NotFound/NotFound'));

const Notifications = loadable(() => import('./Notifications/Notifications'));

const Onboarding = loadable(() => import('./Onboarding/Onboarding'));

const OnboardingClient = loadable(() =>
  import('./OnboardingClient/OnboardingClient')
);

const OnboardingNotifications = loadable(() =>
  import('./OnboardingNotifications/OnboardingNotifications')
);

const PlatformTerms = loadable(() => import('./Terms/PlatformTerms'));

const Pricing = loadable(() => import('./Pricing/Pricing'));

const Post = loadable(() => import('./Post/Post'));

const PostAJobCategory = loadable(() => import('./PostAJob/Category'));

const PostAJobIntent = loadable(() => import('./PostAJob/Intent'));

const PostAJobRole = loadable(() => import('./PostAJob/Role'));

const PostAJobSkills = loadable(() => import('./PostAJob/Skills'));

const PostAJobCapacity = loadable(() => import('./PostAJob/Capacity'));

const PostAJobType = loadable(() => import('./PostAJob/Type'));

const PostAJobDuration = loadable(() => import('./PostAJob/Duration'));

const PostAJobExperience = loadable(() => import('./PostAJob/Experience'));

const PostAJobLikelihood = loadable(() => import('./PostAJob/Likelihood'));

const PostAJobLocations = loadable(() => import('./PostAJob/Locations'));

const PostAJobTitleAndDescription = loadable(() =>
  import('./PostAJob/TitleAndDescription')
);

const PostAJobDeadline = loadable(() => import('./PostAJob/Deadline'));

const PostAJobExamples = loadable(() => import('./PostAJob/Examples'));

const PostAJobBudget = loadable(() => import('./PostAJob/Budget'));

const PostAJobAboutYou = loadable(() => import('./PostAJob/AboutYou'));

const PostAJobEmail = loadable(() => import('./PostAJob/Email'));

const PostAJobPending = loadable(() => import('./PostAJob/Pending'));

const PostAJobUnpaidWork = loadable(() => import('./PostAJob/UnpaidWork'));

const PostAJobFlowShell = loadable(() => import('./PostAJob/PostAJobFlowShell'));

const ReportMessages = loadable(() => import('./Reports/ReportMessages'));

const SignUp = loadable(() => import('./SignUp/SignUp'));

const SignIn = loadable(() => import('./SignIn/SignIn'));

const SimplePayment = loadable(() => import('./Payments/SimplePayment'));

const Shortlist = loadable(() => import('./Shortlist/Shortlist'));

const Undock = loadable(() => import('./Undock/Undock'));

const ViewEarnings = loadable(() => import('./ViewEarnings/ViewEarnings'));

const ViewPayments = loadable(() => import('./ViewPayments/ViewPayments'));

export {
  AnswerPublicQuestion,
  ApplyForVerification,
  Ari,
  AriJobLanding,
  AuthCode,
  Aup,
  BetterPic,
  BillContainer,
  BriefDetailsClient,
  JobDetails,
  RecentJobRedirect,
  Copyright,
  EngagementTerms,
  HowItWorks,
  ManageBriefs,
  ManagePitches,
  MicroProjects,
  Messages,
  NotFound,
  Notifications,
  Onboarding,
  OnboardingClient,
  OnboardingNotifications,
  PlatformTerms,
  Post,
  PostAJobCategory,
  PostAJobIntent,
  PostAJobRole,
  PostAJobSkills,
  PostAJobCapacity,
  PostAJobType,
  PostAJobDuration,
  PostAJobExperience,
  PostAJobLikelihood,
  PostAJobLocations,
  PostAJobTitleAndDescription,
  PostAJobDeadline,
  PostAJobExamples,
  PostAJobBudget,
  PostAJobAboutYou,
  PostAJobEmail,
  PostAJobPending,
  PostAJobUnpaidWork,
  PostAJobFlowShell,
  Pricing,
  ReportMessages,
  Shortlist,
  SignUp,
  SignIn,
  SimplePayment,
  Undock,
  ViewEarnings,
  ViewPayments,
};
